import React from 'react';
import Dialog from '../../element/Dialog/Dialog';
import BtnPrimary from '../../element/Buttons/btnPrimary';
import BtnLight from '../../element/Buttons/btnLight';

/**
 * Reusable Confirmation Dialog for Worker Second Prompts
 * Provides consistent "Are you sure?" modal safeguard before critical status changes or email dispatches.
 */
const ConfirmationDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Are you sure?',
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  variant = 'primary', // 'primary' | 'danger' | 'warning' | 'success'
  isLoading = false,
  width = 440
}) => {
  const getIcon = () => {
    switch (variant) {
      case 'danger':
        return (
          <span className="w-12 h-12 flex justify-center items-center rounded-full bg-red-100 border-8 border-red-50 mx-auto">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#B42318" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
        );
      case 'success':
        return (
          <span className="w-12 h-12 flex justify-center items-center rounded-full bg-green-100 border-8 border-green-50 mx-auto">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 6L9 17L4 12" stroke="#039855" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
        );
      case 'warning':
      default:
        return (
          <span className="w-12 h-12 flex justify-center items-center rounded-full bg-blue-100 border-8 border-blue-50 mx-auto">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#1D2939" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
        );
    }
  };

  const getConfirmButtonClass = () => {
    if (variant === 'danger') {
      return '!bg-red-600 hover:!bg-red-700 !border-red-600';
    }
    return '';
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      bodyOpenClassName="overflow-hidden"
      width={width}
      className="customAlert"
    >
      <div className="pt-6 px-6">
        {getIcon()}
        <p className="text-base text-gray-900 font-semibold text-center mt-4">
          {title}
        </p>
        {message && (
          <p className="text-sm text-gray-600 text-center mt-2 leading-relaxed">
            {message}
          </p>
        )}
      </div>
      <div className="mt-6 flex justify-center pb-6 px-6 gap-3">
        <BtnLight className="flex-1" onClick={onClose} disabled={isLoading}>
          {cancelText}
        </BtnLight>
        <BtnPrimary
          className={`flex-1 ${getConfirmButtonClass()}`}
          onClick={onConfirm}
          disabled={isLoading}
        >
          {isLoading ? 'Processing...' : confirmText}
        </BtnPrimary>
      </div>
    </Dialog>
  );
};

export default ConfirmationDialog;
